import React, { useCallback, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { NavbarMenuItem } from '../CommonTypes';
import { navbarMenuItems } from '../Constants/constants';
import { useReduxDispatch } from '../Store/reduxHooks';
import { setSelectedClosure, setSelectedTab } from '../Store/reducers/Common';
import TopNav from '../SharedComponets/TopNavigation';
import FooterComponent from '../SharedComponets/Footer';
import { MainContainer } from '../Components/globalStyles';

interface RouterContentProps {
  children: React.ReactNode;
}

const RouterContent = ({ children }: RouterContentProps) => {
  const [showOnMobile, setShowOnMobile] = useState(false);
  const [routeKey, setRouteKey] = useState(0);
  const dispatch = useReduxDispatch();
  const history = useHistory();
  const location = useLocation();

  // Memoize the active item calculation to prevent unnecessary re-renders
  const activeItem = useMemo(() => {
    return (
      navbarMenuItems.find((item) => location.pathname.includes(item.link)) ||
      null
    );
  }, [location.pathname]);

  // Memoize filtered navbar items
  const filteredNavbarItems = useMemo(
    () => navbarMenuItems.filter((item) => !item.isHidden),
    []
  );

  const showTopNav = useMemo(
    () =>
      !location.pathname.includes('/AdminGuide') &&
      Boolean(localStorage.getItem('isLoggedIn')),
    [location.pathname]
  );

  const handleItemClick = useCallback(
    (item: NavbarMenuItem) => {
      dispatch(setSelectedTab({ selectedTab: '' }));
      dispatch(setSelectedClosure({ selectedClosure: null }));
      localStorage.setItem('isWebSocketConnected', 'false');

      // Check if clicking on the same route
      if (location.pathname === item.link) {
        // Force refresh by updating the route key to trigger component remount
        setRouteKey((prev) => prev + 1);
      } else {
        history.push(item.link);
      }

      setShowOnMobile(false);
    },
    [dispatch, history, location.pathname]
  );

  const handleMenuToggle = useCallback(() => {
    setShowOnMobile((prev) => !prev);
  }, []);

  const handleMenuClose = useCallback(() => {
    setShowOnMobile(false);
  }, []);

  return (
    <>
      {showTopNav && (
        <TopNav
          items={filteredNavbarItems}
          activeItem={activeItem}
          showOnMobile={showOnMobile}
          handleMenuToggle={handleMenuToggle}
          handleMenuClose={handleMenuClose}
          handleItemClick={handleItemClick}
        />
      )}
      <div
        className="d-flex overflow-auto flex-column flex-grow-1"
        id="layout-container"
      >
        <MainContainer id="main-container" key={routeKey}>
          {children}
        </MainContainer>
        <FooterComponent />
      </div>
    </>
  );
};

export default RouterContent;
